import { z } from 'zod';
import { isoTimestampSchema, uuidSchema } from './common';

export const TICKET_STATUSES = [
  'new',
  'acknowledged',
  'preparing',
  'ready',
  'served',
  'cancelled',
] as const;
export const ticketStatusSchema = z.enum(TICKET_STATUSES);
export type TicketStatus = z.infer<typeof ticketStatusSchema>;

export const kitchenTicketItemSchema = z.object({
  order_item_id: uuidSchema,
  name: z.string(),
  quantity: z.number().int(),
  modifiers: z.array(z.string()),
  notes: z.string().nullable(),
  seat: z.number().int().nullable(),
  status: z.enum(['sent', 'preparing', 'ready', 'served', 'cancelled']),
  cancel_reason: z.string().nullable(),
});

export const kitchenTicketSchema = z.object({
  id: uuidSchema,
  ticket_number: z.string(),
  order_id: uuidSchema,
  order_number: z.string(),
  order_type: z.enum(['dine_in', 'takeaway', 'delivery']),
  channel: z.enum(['walk_in', 'gofood', 'grabfood', 'shopeefood', 'other']),
  external_ref: z.string().nullable(),
  customer_name: z.string().nullable(),
  /** Dine-in only. */
  table_name: z.string().nullable(),
  station_id: uuidSchema,
  station_name: z.string(),
  submission_no: z.number().int(),
  status: ticketStatusSchema,
  items: z.array(kitchenTicketItemSchema),
  version: z.number().int(),
  created_at: isoTimestampSchema,
  acknowledged_at: isoTimestampSchema.nullable(),
  started_at: isoTimestampSchema.nullable(),
  ready_at: isoTimestampSchema.nullable(),
  served_at: isoTimestampSchema.nullable(),
});
export type KitchenTicket = z.infer<typeof kitchenTicketSchema>;

export const kitchenTicketListQuerySchema = z.object({
  station_id: uuidSchema.optional(),
  /** `active` = new/acknowledged/preparing/ready. */
  scope: z.enum(['active', 'recent']).default('active'),
  order_id: uuidSchema.optional(),
});

export const kitchenTicketListResponseSchema = z.object({ items: z.array(kitchenTicketSchema) });

export const updateTicketStatusRequestSchema = z.object({
  expected_version: z.number().int().nonnegative(),
  status: z.enum(['acknowledged', 'preparing', 'ready', 'served', 'cancelled']),
  reason: z.string().trim().max(200).optional(),
});
